import { Link } from "gatsby"
import React from "react"
import "../styles/global.css"
import mainStyles from "../styles/main.module.css"
import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'
import { BsVolumeMuteFill, BsVolumeUpFill } from "react-icons/bs"
import ShareButton from "../components/share-button"
// import ThemeSong from "../data/themeSong.mp3"

const options = {
  // you can also just use 'bottom center'
  position: positions.BOTTOM_CENTER,
  timeout: 5000,
  offset: '30px',
  // you can also just use 'scale'
  transition: transitions.SCALE
}

export default class Home extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isSound: false
    }
    this.toggleSound = this.toggleSound.bind(this)
    if (typeof Audio != "undefined") {
      this.url = "https://cdn.pixabay.com/download/audio/2022/01/04/audio_76201dc554.mp3?filename=far-from-home-acoustic-version-13463.mp3";
      this.audio = new Audio(this.url);
      this.audio.volume = 0.1;
      this.audio.loop = true;
      // this.audio.load();
    }
  }

  toggleSound() {
    if (!this.state.isSound) {
      this.audio.play();
    } else {
      this.audio.pause();
    }
    this.setState({isSound: !this.state.isSound})
  }

  render() {
    return (
      <div className={mainStyles.pageWrapper}>
        <ShareButton />
        <AlertProvider template={AlertTemplate} {...options}>
              <div className={mainStyles.gameTitle}>
                The Tobacco Pandemic
              </div>
              <Link to="/start-game/" onClick={() => {this.audio.pause(); this.setState({isSound: false});}}>
                <div className={mainStyles.mainOption}>
                  Start Game
                </div>
              </Link>
            
              <Link to="/game-instructions/" onClick={() => {this.audio.pause(); this.setState({isSound: false});}}>
                <div className={mainStyles.mainOption}>
                  Instructions
                </div>
              </Link>
            
              <Link to="/resources/" onClick={() => {this.audio.pause(); this.setState({isSound: false});}}>
                <div className={mainStyles.mainOption}>
                  Learn More
                </div>
              </Link>
              <Link to="/about/" onClick={() => {this.audio.pause(); this.setState({isSound: false});}}>
                <div className={mainStyles.mainOption}>
                  About
                </div>
              </Link>
              <div>
                © 2021. California Department of Public Health. Bay Area Community Resources - APICHAT. 
                <br />
                This material made possible by funds received from the California Department of Public Health, under contract # 17-10967.
              </div>
                
              
              {typeof Audio != "undefined"? <button onClick={this.toggleSound} className={mainStyles.soundButton}>
                {this.state.isSound? <BsVolumeUpFill />: <BsVolumeMuteFill />}
              </button>: <div />}        

          </AlertProvider>
      </div>
            )
    }
}